@if(!isDataReady){
<p-skeleton styleClass="mb-2" />
<p-skeleton styleClass="mb-2" />

<p-skeleton width="75%" styleClass="mb-2" />
<p-skeleton width="75%" styleClass="mb-2" />

<p-skeleton width="10rem" styleClass="mb-2" />
<p-skeleton width="10rem" styleClass="mb-2" />

<p-skeleton width="5rem" styleClass="mb-2" />
<p-skeleton width="5rem" styleClass="mb-2" />
}
@else{

<form [formGroup]="projectInfoForm" class="grid" (ngSubmit)="onSubmit()">
    <div class="col-12 xl:col-6 lg:col-6 p-2">
        <p-floatLabel>
            <input pInputText id="username" formControlName="codeName" />
            <label for="username">{{ 'Project Code Name' | sentenceCase }}<span class="required">*</span></label>
        </p-floatLabel>
        <div>
            @if(form['codeName'].dirty || form['codeName'].touched){
            @if(form['codeName'].errors?.['required']){
            <div class="p-error ">This is required.</div>
            }
            @if(form['codeName'].errors?.['pattern']){
            <div class="p-error">Only 100 characters of Alphanumeric, Hyphens(-) and Spaces are allowed.</div>
            }
            }
        </div>
    </div>

    <div class="col-12 xl:col-6 lg:col-6 p-2">
        <p-floatLabel>
            <input pInputText id="conflict-parties" formControlName="client" />
            <label for="conflict-parties">{{ 'Conflict parties' | sentenceCase }}</label>
        </p-floatLabel>
    </div>

    @if (isClientPortalEnabled()) {
        <div class="col-12 xl:col-6 lg:col-6 p-2">
            <p-floatLabel>
                <p-multiSelect
                    [options]="clientGroups()"
                    formControlName="clientGroups"
                    optionLabel="name"
                    optionValue="_id"
                    placeholder="Select Client Groups"
                    class="w-full"
                    id="client-groups">
                </p-multiSelect>
                <label for="client-groups">{{ 'Client groups' | sentenceCase }}</label>
            </p-floatLabel>
            <small class="client-groups-help">Selected groups get client portal access to this project. None selected means no client access.</small>
        </div>
    }

  <div class="col-12 xl:col-6 lg:col-6">
    <p-floatLabel>
      <p-multiSelect 
        [options]="projectOwners" 
        formControlName="owner"
        optionLabel="name" 
        placeholder="Select Project Owners"
        class="w-full"
        id="project-owners">
      </p-multiSelect>
      <label for="project-owners">{{ 'Project Owners' | sentenceCase }}<span class="required">*</span></label>
    </p-floatLabel>
    @if(form['owner'].invalid && (form['owner'].dirty || form['owner'].touched)){
    <div  class="p-error">
        Project owners are required
    </div>
    }
</div>
    <div class="col-12 xl:col-6 lg:col-6 p-2">
        @if(user.firm.isCommunicationPlatformEnabled){
        <div class="w-full">
            <p-floatLabel>
                <p-dropdown [options]="communicationOwners" optionLabel="name" inputId="float-label"
                    formControlName="selectedCommunicationPlatforms" />
                <label for="float-label">{{ 'Communication Owner' | sentenceCase }}</label>
            </p-floatLabel>
        </div>
        }
    </div>
    @if(user.firm.isCommunicationPlatformEnabled &&
    getFormValuesByProperty('communicationPlatform')?.platformId){
    <div class="col-12 xl:col-6 lg:col-6 p-2">
        <div class="w-full">
            <p-floatLabel>
                <input pInputText id="username" formControlName="communicationPlatformUrl" />
                <label for="float-label">{{ 'Communication Platform URL' | sentenceCase }}<span class="required">*</span></label>
            </p-floatLabel>
            @if((form['communicationPlatformUrl'].dirty || form['communicationPlatformUrl'].touched) &&
            !getFormValuesByProperty('communicationPlatformUrl')){
            <div class="p-error">This is required.</div>
            }
            @if((form['communicationPlatformUrl'].dirty || form['communicationPlatformUrl'].touched) &&
            getFormValuesByProperty('communicationPlatformUrl') &&
            !isValidURL(getFormValuesByProperty('communicationPlatformUrl'))){
            <div class="p-error">Invalid URL.</div>
            }
        </div>
    </div>
    }
    <div class="col-12 xl:col-6 lg:col-6 p-2">
        @if(user.firm.isCommunicationPlatformEnabled){
        <div class="w-full">
            <p-floatLabel>
                <p-dropdown [options]="reviewerPlatforms" optionLabel="name" inputId="float-label"
                    formControlName="selectedReviewerPlatform" />
                <label for="float-label">{{ 'Review Platform' | sentenceCase }}</label>
            </p-floatLabel>
        </div>
        }
    </div>

    @if(user.firm.isCommunicationPlatformEnabled && getFormValuesByProperty('reviewerPlatform')?.platformId){
    <div class="col-12 xl:col-6 lg:col-6 p-2">
        <div class="w-full">
            <p-floatLabel>
                <input pInputText id="username" formControlName="reviewerPlatformUrl" />
                <label for="float-label">{{ 'Review Platform URL' | sentenceCase }}<span class="required">*</span></label>
            </p-floatLabel>
            @if((form['reviewerPlatformUrl'].dirty || form['reviewerPlatformUrl'].touched) &&
            !getFormValuesByProperty('reviewerPlatformUrl')){
            <div class="p-error">This is required.</div>
            }
            @if((form['reviewerPlatformUrl'].dirty || form['reviewerPlatformUrl'].touched) &&
            getFormValuesByProperty('reviewerPlatformUrl') &&
            !isValidURL(getFormValuesByProperty('reviewerPlatformUrl'))){
            <div class="p-error">Invalid URL.</div>
            }
        </div>
    </div>
    }

    @if(isInvoiceTimeKeepingEnabled()){
    <div class="p-0 my-4 col-12 flex flex-row gap-3 pl-2">
        <p class=" text-black-alpha-90 m-0">{{ 'Enable Contractor Timekeeping?' | sentenceCase }}</p>
        <label>No</label>
        <p-inputSwitch formControlName="contractorTimekeepingEnabled" />
        <label>Yes</label>
    </div>
    }
    <div *ngIf="user.firm.isPresumptiveEnabled"
        class="p-0 mb-4 col-12 flex flex-column xl:flex-row gap-3 xl:gap-6 pl-2">
        <p class=" text-black-alpha-90 m-0">{{ 'How would you like to staff this project?' | sentenceCase }}</p>
        <div class="flex align-items-center">
            <p-radioButton [value]="false" formControlName="isPresumptiveEnabled" inputId="traditional" />
            <label for="traditional" class="ml-2">
                {{ 'Staff Up and Go' | sentenceCase }}
            </label>
            <span 
            pTooltip="Candidates that accept offers are will be placed on actual positions. No approval necessary."
            tooltipPosition="top" icon="true"
            class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer text-primary-600 ml-2"></span>
        </div>
        <div class="flex align-items-center">
            <p-radioButton [value]="true" formControlName="isPresumptiveEnabled" inputId="presumptively" />
            <label for="presumptively" class="ml-2">
                {{ 'Staff Up Pending Team Approval' | sentenceCase }}
            </label>
            <span 
            pTooltip="Candidates that accept offers will still need final approval from a {{ user.firm.name }} manager prior to being given a position on the project. Candidates can be approved or denied from the project’s Staff List screen."
            tooltipPosition="top" icon="true"
            class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer text-primary-600 ml-2"></span>
        </div>
    </div>
    @if(user?.firm?.payroll?.enabled){
    <div class="p-0 mb-4 col-12 flex flex-row gap-3 pl-2" formGroupName="tsheet">
        <p class=" text-black-alpha-90 m-0">{{ 'Enable Timekeeping?' | sentenceCase }}</p>
        <label>No</label>
        <p-inputSwitch formControlName="isEnabled" />
        <label>Yes</label>
    </div>
    }
    <div *ngIf="user.firm.isBackgroundCheckRequired" class="p-0 mb-4 col-12 flex flex-row gap-3 pl-2">
        <p class=" text-black-alpha-90 m-0">{{ 'Run criminal background check?' | sentenceCase }}</p>
        <label>No</label>
        <p-inputSwitch formControlName="backgroundCheckRequired" />
        <label>Yes</label>
    </div>
    <div *ngIf="user.firm.isCivilLitigationEnabled" class="p-0 mb-4 col-12 flex flex-row gap-3 pl-2">
        <p class=" text-black-alpha-90 m-0">{{ 'Run civil litigation screening?' | sentenceCase }}</p>
        <label>No</label>
        <p-inputSwitch formControlName="civilLitigationScreeningRequired" />
        <label>Yes</label>
    </div>

    <div class="col-12 p-0 flex justify-content-end gap-3">
        <p-button label="cancel" (click)="onCancel()" [outlined]="true" [rounded]="true" size="large" />
        <p-button type="submit" label="next" [rounded]="true" size="large" />
    </div>
</form>
}